import API from './api';
import type {
  ScraperSource,
  ScraperTrigger,
  ScraperSchedule,
  ScraperStats,
  ScraperSourceType,
  ScraperSourceCategory,
} from '../types/scraper';

export const scraperSourcesApi = {
  getAll: async (filters?: { type?: ScraperSourceType; category?: ScraperSourceCategory; enabled?: boolean; region?: string }): Promise<ScraperSource[]> => {
    const params = new URLSearchParams();
    if (filters?.type) params.append('type', filters.type);
    if (filters?.category) params.append('category', filters.category);
    if (filters?.enabled !== undefined) params.append('enabled', String(filters.enabled));
    if (filters?.region) params.append('region', filters.region);
    const query = params.toString();
    const response = await API.get(`/api/admin/scraper/sources${query ? `?${query}` : ''}`);
    return response.data;
  },

  create: async (data: Partial<ScraperSource>): Promise<ScraperSource> => {
    const response = await API.post('/api/admin/scraper/sources', data);
    return response.data;
  },

  update: async (id: string, data: Partial<ScraperSource>): Promise<ScraperSource> => {
    const response = await API.put(`/api/admin/scraper/sources/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await API.delete(`/api/admin/scraper/sources/${id}`);
  },
};

export const scraperTriggersApi = {
  create: async (data: {
    tier?: number;
    sourceType?: ScraperSourceType;
    sourceId?: string;
  }): Promise<ScraperTrigger> => {
    const response = await API.post('/api/admin/scraper/trigger', data);
    return response.data;
  },

  getRecent: async (): Promise<ScraperTrigger[]> => {
    const response = await API.get('/api/admin/scraper/triggers');
    return response.data;
  },
};

export const scraperSchedulesApi = {
  getAll: async (): Promise<ScraperSchedule[]> => {
    const response = await API.get('/api/admin/scraper/schedules');
    return response.data;
  },

  create: async (data: {
    tier?: number;
    intervalHours: number;
    runAtHour?: number;
    enabled?: boolean;
  }): Promise<ScraperSchedule> => {
    const response = await API.post('/api/admin/scraper/schedules', data);
    return response.data;
  },

  update: async (
    id: string,
    data: { intervalHours?: number; runAtHour?: number; enabled?: boolean }
  ): Promise<ScraperSchedule> => {
    const response = await API.put(`/api/admin/scraper/schedules/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await API.delete(`/api/admin/scraper/schedules/${id}`);
  },
};

export const scraperStatsApi = {
  get: async (): Promise<ScraperStats> => {
    const response = await API.get('/api/admin/scraper/stats');
    return response.data;
  },
};

export interface ScraperCaseStats {
  total: number;
  byStatus: Record<string, number>;
}

export const scraperCaseStatsApi = {
  get: async (): Promise<ScraperCaseStats> => {
    const response = await API.get('/api/scraper/cases/stats');
    return response.data;
  },
};
